import React from 'react';
import { MainContainerLayout } from 'clorian-frontend-components';
import VerifierSelection from '../components/VerifierSelection';

const VerifierSelectionView = () => (
  <div>
    <MainContainerLayout>
      <VerifierSelection />
    </MainContainerLayout>
  </div>
);

export default VerifierSelectionView;
